<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('business.label.specification')" type="confirm" width="50%" @confirm="confirm">
    <vxe-card v-if="selectType==='checkbox'">
      <vxe-button icon="vxe-icon-square-close" mode="text" status="danger" @click="closeTag()"/>
      <vxe-tag v-for="row in selectedRows" :key="row.id" :content="row.specification.length>10?row.specification.slice(0,10)+'...':row.specification" :title="row.specification" closable color="blue" @close="closeTag(row)"/>
    </vxe-card>
    <vxe-card>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        :row-config="{useKey:true, keyField: 'id'}"
        @checkbox-all="({checked})=>checkAll(checked)"
        @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="specification" title="business.label.specification" width="200"/>
        <vxe-column field="uom" title="business.label.uom" width="60"/>
        <vxe-column field="factor" title="business.label.factor" width="60"/>
        <vxe-column field="item.name" title="business.label.itemName" width="300"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="master" title="business.label.master" width="60"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  props: {
    selectType: { type: String, default: 'radio' }
  },
  data() {
    return {
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: { 'item.id': null },
      args: null,
      selectedRows: [],
      record: undefined,
      page: 1,
      size: 15
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    init(args) {
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      setTimeout(() => {
        this.fetch()
      }, 300)
    },
    fetch() {
      if (this.query['item.id'] === null || this.query['item.id'] === undefined) {
        return this.$message.warning('请先选择商品')
      }
      this.loading = true
      findAll('packFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      if (selectedRows.length > 0) this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>